'use strict';

import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import BaseComponent from './BaseComponent';
import { clickButton } from '../../actions/Modal';
import Style from './UserSelectList.cssmodule.less';
import Button from '../CommonSet/Button';
import Title from '../CommonSet/Title';
import Dropdown from '../CommonSet/Dropdown';

class UserSelectList extends BaseComponent {
    constructor(props) {
        super(props);
        this.Style = Style;
        this.selectedItem = undefined;

        this.state = {
            showAlert: false,
        };
        this.createContent = this.createContent.bind(this);
        this.handleDropdownItemSelected = this.handleDropdownItemSelected.bind(
            this
        );
    }

    handleButtonClick(event) {
        if (event === 'ok' && !this.isItemSelected) {
            if (!this.state.showAlert) {
                this.setState({
                    showAlert: true,
                });
            }
        } else {
            const { clickButton } = this.props.actions;
            clickButton({
                event,
                data: this.selectedItem,
            });
        }
    }

    handleDropdownItemSelected(item) {
        this.isItemSelected = true;
        this.selectedItem = item;
    }

    createContent(content) {
        let view = null;
        try {
            if (typeof content === 'object') {
                view = (
                    <div
                        className={Style.content}
                        dangerouslySetInnerHTML={{ __html: content.outerHTML }}
                    />
                );
            } else if (typeof content === 'string') {
                view = <div className={Style.content}>{content}</div>;
            }
        } catch (e) {}

        return view;
    }

    render() {
        const { item = {} } = this.props;
        const getLang = this.Utils.getLang;

        return (
            <div className={this.Style.main}>
                <Title
                    className={this.Style.title}
                    isClose
                    onClose={() => this.handleButtonClick('close')}
                >
                    {getLang('Menus.popup_notice')}
                </Title>
                <div className={this.Style.contentView}>
                    {this.createContent(
                        getLang('Menus.select_email_unauthenticated_user')
                    )}
                    <Dropdown
                        placeholder={getLang('Menus.select_user')}
                        list={item.list || []}
                        onItemChange={this.handleDropdownItemSelected}
                    />
                    {this.state.showAlert && (
                        <div className={this.Style.noSelectAlert}>
                            {getLang('Menus.select_user')}
                        </div>
                    )}
                    <Button
                        className={this.Style.button}
                        text={getLang('Menus.send')}
                        onClick={() => this.handleButtonClick('ok')}
                    />
                </div>
            </div>
        );
    }
}

UserSelectList.displayName = 'UserSelectList';
UserSelectList.propTypes = {};

function mapDispatchToProps(dispatch) {
    const actions = { clickButton };
    return { actions: bindActionCreators(actions, dispatch) };
}

export default connect(
    undefined,
    mapDispatchToProps
)(UserSelectList);



// WEBPACK FOOTER //
// ./components/ModalSet/UserSelectList.js